// extracted by mini-css-extract-plugin
export default {"lineButtons":"realEstateItem_lineButtons__fAGWW","headers":"realEstateItem_headers__x5q5k","twoInLine":"realEstateItem_twoInLine__TW-Q6"};